import { render } from "./ModalLayout.vue?vue&type=template&id=5b063297&scoped=true"
const script = {}

import "./ModalLayout.vue?vue&type=style&index=0&id=5b063297&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b063297"]])

export default __exports__